import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import {
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../../components/MaterialInput";
import MaterialBox from "../../../components/MaterialBox";
import MaterialButton from "../../../components/MaterialButton";
import { useLocation, useNavigate } from "react-router-dom";
import { BsFillPersonBadgeFill } from "react-icons/bs";
import { useAuth } from "../../../context/AuthContext/AuthContextProvider";
import { AddRoleMutation } from "../../../lib/graphQL/graphMutation";
import request, { gql } from "graphql-request";
import BASEURL from "../../Utils/Baseurl";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  deleteRoleService,
  updateRoleService,
} from "../../../lib/appUtliz/RoleSevice";
import { useLoading } from "../../../context/LodingContext";
import { useError } from "../../../context/ErrorContext";
import { useSuccess } from "../../../context/SucccessContext";
import MaterialSelect from "../../../components/MasterSelect";

const getRoleDetailById = gql`
  query getRoledetailbyId($id: String!) {
    getRoleDetailById(id: $id) {
      id
      status
      lastUpdate
      role
    }
  }
`;

export default function AddRole() {

  const roleOptions = [
    { value: "Manager", label: "Manager"},
    { value: "Employee", label: "Employee"}
  ]
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useLocation();
  const id = params.search.slice(1);
  const { circleLoading, setCirleLoading } = useLoading();
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const { errorStatus, setErrorStatus } = useError();

  const [selectedData, setSelectedData] = useState([]);
  const [pendingLoading, setPendingLoading] = useState(false);
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });
  const [roleData, setRoleData] = useState({
    // Role Details
    role: "",

    // Role Status
    roleStatus: "unchecked",
  });
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
    done: "",
    back: "",
  });


  //UseEffect for Page Toggle
  useEffect(() => {
    setTogglePage({
      ...togglePage,
      view: params?.search !== "" ? true : false,
    });
  }, []);

  //UseEffect to fetch by Id
  useEffect(() => {
    if (id) {
      fetchUpdateValue();
    }
  }, [id]);

  //Fetch Role Data By ID
  const fetchUpdateValue = async () => {
    try {
      const res = await request(BASEURL, getRoleDetailById, {
        id: id,
      });

      const v = res.getRoleDetailById;
      setSelectedData(v);

      setRoleData({
        role: {
          value: v.role,
          label: v.role
        },
        roleStatus: "success",
      });

    } catch (err) {
      console.error("Couldn't fetch Data: ",err)
    }
  };

  //Create Mutation
  const handleAddRoleData = async () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to submit your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        setCirleLoading(true);
        try {
          const response = await request(BASEURL, AddRoleMutation, {
            user: currentUser?.id,
            role: roleData.role?.value,
          });
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });

          setSuccessStatus(true);
          setSucessTitle("Created");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/role");
          }, 1000);
        } catch (error) {
          console.error(error);
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
          setErrorStatus(true);
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        } finally {
          setCirleLoading(false);
        }
      },

      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //Update Mutation
  const handleEditRoleData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to edit your details.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        const values = {
          role: roleData.role?.value,
        };
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(true);
        const updateStatus = await updateRoleService(values, id);
        setCirleLoading(false);
        if (updateStatus) {
          setSuccessStatus(true);
          setSucessTitle("Updated");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/role");
          }, 1000);
        } else {
          setErrorStatus(true);
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //Delete Function
  const handleDelteRoleData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your detail.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setPendingLoading(true);
        const delteStatus = await deleteRoleService(id);
        setPendingLoading(false);
        if (delteStatus) {
          setSuccessStatus(true);
          setSucessTitle("Deleted");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/role");
          }, 1000);
        } else {
          setErrorStatus(true);
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //Submit Validation
  const checkAllFields = () => {
    let allowSubmit = false;
      if (roleData.roleStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    return allowSubmit;
  };

  //Discard Function
  const handleDiscardButton = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setRoleData({
      role: {
        value: selectedData?.role,
        label: selectedData?.role,
      },
      roleStatus: "success",
    });
  };

  //Cancel Function
  const handleCancelRoleData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "The Entered Details will not be saved. Do you want to Cancel it?",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        // const delteStatus = await deleteBrandService(id);
        // if (delteStatus) {
        navigate("/role");
        // } else if (!delteStatus) {
        // }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //Handle Change
  const handleRoleData = (event, selectEvent) => {
    let roleState = { ...roleData };
  
    // Handle MaterialSelect (dropdown)
    if (!event?.target && selectEvent) {
      switch (selectEvent.name) {
        case "role": {
          const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{2,25})$");
          if (alphaNLenghthRegex.test(event?.trim?.())) {
            roleState[selectEvent.name + "Status"] = "success";
          } else {
            roleState[selectEvent.name + "Status"] =
              event === "" ? "unchecked" : "error";
          }
          roleState[selectEvent.name] = event;
          break;
        }
      }
    }
  
    // Handle normal input fields
    else if (event && event.target) {
      switch (event.target.name) {
        case "role": {
          const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{2,25})$");
          if (alphaNLenghthRegex.test(event.target.value?.trim())) {
            roleState[event.target.name + "Status"] = "success";
          } else {
            roleState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
          roleState[event.target.name] = event.target.value;
          break;
        }
      }
    }
  
    setRoleData(roleState);
  };
  
  
  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
          done={confirmationDialog.done}
          back={confirmationDialog.back}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              {togglePage.view === true || togglePage.edit === true ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                      Role Details
                    </MaterialTypography>
                  </Stack>
                  <ButtonGroup
                    variant="outlined"
                    aria-label="Loading button group"
                  >
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      size="small"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      size="small"
                      onClick={handleDelteRoleData}
                      startIcon={<DeleteIcon />}
                    >
                      delete
                    </MaterialButton>
                  </ButtonGroup>
                </Stack>
              ) : (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Add Role Details
                    </MaterialTypography>
                  </Stack>
                </Stack>
              )}
            </>
          }
        />
        <CardContent sx={{ minHeight: "50vh" }}>
          <Stack direction="row" spacing={1} bgcolor={"#f5f5f5"}>
            <BsFillPersonBadgeFill style={{ fontSize: 20,color:'#460058' }} />
            <MaterialTypography
             sx={{color:'#460058',fontFamily:'Aptos'}}
              component="label"
              variant="body2"
              fontWeight="700"
            >
              Role Information
            </MaterialTypography>
          </Stack>

          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Role <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="role"
                  size="small"
                  placeholder="eg. Admin,Exective,Employee..."
                  value={roleData.role}
                  options={roleOptions}
                  onChange={handleRoleData}
                  error={roleData.roleStatus === "error" ? true : false}
                  isDisabled={togglePage?.view === true ? true : false}
                  success={roleData.roleStatus === "success" ? true : false}
                />
                {roleData.roleStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Role should be maximum 20 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
            </Grid>
          </MaterialBox>
          <MaterialBox
            mt={3}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            {togglePage.edit === true ? (
              <>
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  onClick={handleDiscardButton}
                >
                  Discard
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  size="small"
                  color="dark"
                  disabled={!checkAllFields()}
                  onClick={handleEditRoleData}
                >
                Update
                </MaterialButton>
              </>
            ) : togglePage.view === false && togglePage.edit === false ? (
              <>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  size="small"
                  onClick={handleCancelRoleData}
                >
                  Cancel
                </MaterialButton>
                 <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  size="small"
                  disabled={!checkAllFields()}
                  onClick={handleAddRoleData}
                >
                  Submit
                </MaterialButton>
              </>
            ) : null}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}
